import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as actions from '../../actions';

import Sidebar from '../../components/Sidebar/Sidebar';

const mapStateToProps = ({ auth: { profile }, venue: { selected: venue } }) => ({ profile, venue });

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

const SidebarContainer = connect(mapStateToProps, mapDispatchToProps)(Sidebar);

export default SidebarContainer;



// WEBPACK FOOTER //
// ./src/containers/Sidebar/SidebarContainer.js